import "@/App.css";
import PortfolioHome from "@/pages/PortfolioHome";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ContentProvider } from "@/context/ContentProvider";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import SupportPage from "@/pages/SupportPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import SearchLandingPage from "@/pages/SearchLandingPage";


function App() {
  return (
    <ContentProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PortfolioHome />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/products/:slug" element={<SearchLandingPage kind="product" />} />
          <Route path="/solutions/:slug" element={<SearchLandingPage kind="solution" />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </ContentProvider>
  );
}

export default App;
